export class Asset {
  public id?: string;
  public name: string;
}
